import { ReactNode } from "react";

import { Skeleton } from "@/components/ui/skeleton";

type Props = {
  title: string;
  children: ReactNode;
  rightElement?: ReactNode;
  isLoading?: boolean;
};

function ChartSkeleton() {
  return (
    <div className="h-full w-full flex flex-col gap-4 pt-4">
      <div className="flex gap-2">
        <Skeleton className="h-4 w-12" />
        <Skeleton className="h-4 w-12" />
        <Skeleton className="h-4 w-12" />
      </div>
      <div className="flex-1 flex items-end gap-2">
        <Skeleton className="h-[60%] w-8" />
        <Skeleton className="h-[80%] w-8" />
        <Skeleton className="h-[45%] w-8" />
        <Skeleton className="h-[70%] w-8" />
        <Skeleton className="h-[55%] w-8" />
        <Skeleton className="h-[90%] w-8" />
        <Skeleton className="h-[40%] w-8" />
        <Skeleton className="h-[75%] w-8" />
        <Skeleton className="h-[50%] w-8" />
        <Skeleton className="h-[65%] w-8" />
        <Skeleton className="h-[85%] w-8" />
        <Skeleton className="h-[35%] w-8" />
      </div>
    </div>
  );
}

export default function DashboardCardHeader({
  title,
  children,
  rightElement,
  isLoading = false,
}: Props) {
  return (
    <div className="flex flex-col">
      <div className="h-14 px-5 py-4 bg-white rounded-t-xl outline outline-1 outline-gray-D flex justify-between items-center text-gray-A text-sm font-semibold">
        <span>{title}</span>
        {rightElement && <div>{rightElement}</div>}
      </div>
      <div className="h-[317px] overflow-y-auto px-7 pb-5 bg-white rounded-b-xl outline outline-1 outline-gray-D">
        {isLoading ? <ChartSkeleton /> : children}
      </div>
    </div>
  );
}
